<template>
  <section>
    <ServiceProviderSelector v-if="infoAvaliable" :origin="origin_direction" :destination="destination_direction" :parcels="parcels" :insurance="insurance_information" :primary-action-text="primaryActionText" :secondary-action-text="secondaryActionText" @primary-action="primaryAction" @secondary-action="secondaryAction">
    </ServiceProviderSelector>
  </section>
</template>

<script>
import commons from '../../commons'
import api from '../../commons/api'
import ServiceProviderSelector from '../ServiceProviderSelector'

export default {
  name: 'EditShipmentDestination',
  data () {
    return {
      infoAvaliable: false,

      primaryActionText: 'Aplicar Cambios',
      secondaryActionText: 'Cancelar',

      origin_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      destination_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      parcels: [
        {
          depth: '',
          width: '',
          height: '',
          weight: ''
        }
      ],
      insurance_information: {}
    }
  },
  methods: {
    ...commons.serviceProvider.methods,
    primaryAction (shippingOption) {
      console.log('primary', shippingOption)
      this.updateShipment(shippingOption)
    },
    secondaryAction () {
      console.log('secondary')
      this.$router.push(`/shipments/${this.$route.params['id']}`)
    },
    updateShipment (selectedService) {
      const requestBody = {
        selected_service: selectedService
      }

      this.setNewShipmentRequestBody(requestBody)
      api.shipment.update(this.$route.params['id'], requestBody).then(() => {
        this.getAllShipments()
        this.$router.push(`/shipments/${this.$route.params['id']}`)
      })
    }
  },
  computed: commons.serviceProvider.computed,
  created () {
    api.shipment
      .getByID(this.$route.params['id'])
      .then(response => {
        this.origin_direction = response.data.origin_direction
        this.destination_direction = response.data.destination_direction
        this.parcels = response.data.parcels
        this.insurance_information = response.data.insurance_information

        this.infoAvaliable = true
      })
  },
  components: {
    ServiceProviderSelector: ServiceProviderSelector
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/editShipment/EditShipmentServiceProvider.vue